import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FeatureName } from '../enums/feature-name';

export interface ExperienceFlagResult {
  featureName: string;
  userId: string;
  globallyEnabled: boolean;
  optedOut: boolean;
  effectiveValue: boolean;
  lastModified: string | null;
}

export interface GlobalExperienceFlagResult {
  featureName: string;
  globallyEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class ExperienceFlagsService {
  private readonly baseUrl = environment.configurationApiUrl;

  constructor(private http: HttpClient) {}

  getFlagForUser(featureName: FeatureName, userId: string): Observable<ExperienceFlagResult> {
    return this.http.get<ExperienceFlagResult>(
      `${this.baseUrl}/api/admin/features/${featureName}/users/${userId}`
    );
  }

  getFlagForUsers(featureName: FeatureName, userIds: string[]): Observable<ExperienceFlagResult[]> {
    return this.http.post<ExperienceFlagResult[]>(
      `${this.baseUrl}/api/admin/features/${featureName}/users`,
      { userIds }
    );
  }

  getGlobalFlagState(featureName: FeatureName): Observable<GlobalExperienceFlagResult> {
    return this.http.get<GlobalExperienceFlagResult>(
      `${this.baseUrl}/api/admin/features/${featureName}`
    );
  }
}
